import { useCallback } from "react";

export const useVisaRules = () => {
  const getCoverageOptions = useCallback((visaType) => {
    if (visaType === "Super Visa") {
      return [
        { value: 100000, label: "$100,000" },
        { value: 150000, label: "$150,000" },
        { value: 200000, label: "$200,000" },
        { value: 250000, label: "$250,000" },
        { value: 300000, label: "$300,000" },
        { value: 500000, label: "$500,000" },
        { value: 1000000, label: "$1,000,000" },
      ];
    } else {
      return [
        { value: 10000, label: "$10,000" },
        { value: 15000, label: "$15,000" },
        { value: 25000, label: "$25,000" },
        { value: 50000, label: "$50,000" },
        { value: 100000, label: "$100,000" },
        { value: 150000, label: "$150,000" },
        { value: 200000, label: "$200,000" },
        { value: 250000, label: "$250,000" },
        { value: 300000, label: "$300,000" },
        { value: 500000, label: "$500,000" },
        { value: 1000000, label: "$1,000,000" },
      ];
    }
  }, []);


  return {
    getCoverageOptions
  };
};
